import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { settings } from '~common/app/app.settings';
import { superSessionStorage } from '~common/app/shared/utils/session-storage';

import { AuthService } from '../../../auth/services/auth.service';

declare let FreshworksWidget: any;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.sass']
})
export class SidebarComponent implements OnInit {
  authenticated$: any;
  activeCampaigns = superSessionStorage.get('sidebar.campaigns') || 0;
  SSOEnabled = false;

  constructor(
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.authenticated$ = this.authService.getAuthenticatedUser();
    this.SSOEnabled = settings.app.SSOEnabled;
    this.loadCampaignCounters();
  }

  logout() {
    this.authService.logout();
  }

  onOpenHelp() {
    if (FreshworksWidget) {
      FreshworksWidget('show', 'launcher');
      FreshworksWidget('open');
    }
  }

  hasScope(scope) {
    return this.authService.hasScope(scope);
  }

  loadCampaignCounters() {
    this.authService.loadMetrics();

    this.authService.getLoadedMetrics().subscribe((response: any) => {
      const strategies = response.strategies;
      let total = 0;

      if (!strategies) { return; }

      Object.keys(strategies).forEach((key) => {
        total += strategies[key];
      });

      this.activeCampaigns = total;
    });
  }
}
